import React from "react";

const Youtube = ({ ClickHandler, showI = false, Children }) => {
  return (
    <a
      onClick={ClickHandler}
      className="youtube"
      href="https://www.youtube.com/@biblenom"
      rel="nofollow noreferrer"
      target="_blank"
    >
      {showI && <i className="fab fa-youtube"></i>}
      {Children}
    </a>
  );
};

export default Youtube;
